const LayoutMain = ({ children }: any) => (
  <div>
    
    <div className="main">{children}</div>
  </div>
);

export default LayoutMain;
